export const ROUTE_BASE_NAME = "tracking";

export const ROUTE_NAMES = {
  trackingList: `${ROUTE_BASE_NAME}.list`,
  trackingLocation: `${ROUTE_BASE_NAME}.location`,
};
